import React from "react";
import { DS } from "../theme";

export default function StatsPanel({ stats }) {
  const { wins=0, losses=0, draws=0, gamesPlayed=0, currentStreak=0, maxStreak=0,
          checkmateWins=0, fastWins=0, pvpWins=0, botWins={}, botLosses={} } = stats;

  const winRate = gamesPlayed > 0 ? Math.round((wins / gamesPlayed) * 100) : 0;
  const difficulties = ["easy","novice","intermediate","advanced","pro"];
  const diffLabels   = { easy:"Easy", novice:"Novice", intermediate:"Intermediate", advanced:"Advanced", pro:"Pro" };

  return (
    <div>
      {/* Overview grid */}
      <div style={card}>
        <div style={label}>Overview</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 10 }}>
          <StatBox value={wins}    sub="Wins"    color={DS.success} />
          <StatBox value={losses}  sub="Losses"  color={DS.danger}  />
          <StatBox value={draws}   sub="Draws"   color={DS.warning} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 10 }}>
          <StatBox value={gamesPlayed} sub="Games Played" />
          <StatBox value={`${winRate}%`} sub="Win Rate" color={winRate >= 50 ? DS.success : DS.danger} />
        </div>
      </div>

      {/* Streaks */}
      <div style={card}>
        <div style={label}>Streaks</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 10 }}>
          <StatBox value={currentStreak} sub="Current Streak" suffix=" †" />
          <StatBox value={maxStreak}    sub="Best Streak"    suffix=" ✶" />
        </div>
      </div>

      {/* Milestones */}
      <div style={card}>
        <div style={label}>Milestones</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
          <StatBox value={checkmateWins} sub="Checkmates" />
          <StatBox value={fastWins}      sub="Speed Wins" />
          <StatBox value={pvpWins}       sub="PvP Wins" />
        </div>
      </div>

      {/* Bot record */}
      <div style={card}>
        <div style={label}>Bot Record</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: `1px solid ${DS.borderFaint}` }}>
              {["Difficulty","Wins","Losses","Win %"].map(h => (
                <th key={h} style={{ padding: "6px 8px", textAlign: "left", fontSize: 10, color: DS.textFaint, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {difficulties.map(d => {
              const w = botWins[d] || 0, l = botLosses[d] || 0, tot = w + l;
              const wr = tot > 0 ? Math.round((w/tot)*100) : null;
              return (
                <tr key={d} className="tbl-row" style={{ borderBottom: `1px solid ${DS.borderFaint}` }}>
                  <td style={{ padding: "9px 8px", color: DS.textMuted, fontWeight: 500 }}>{diffLabels[d]}</td>
                  <td style={{ padding: "9px 8px", color: DS.success, fontWeight: 700 }}>{w}</td>
                  <td style={{ padding: "9px 8px", color: DS.danger,  fontWeight: 700 }}>{l}</td>
                  <td style={{ padding: "9px 8px", color: DS.textMuted }}>
                    {wr !== null ? (
                      <span style={{ color: wr >= 50 ? DS.success : DS.danger }}>{wr}%</span>
                    ) : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Global teaser */}
      <div style={{
        ...card,
        background: "linear-gradient(135deg, rgba(115,102,240,0.1), rgba(115,102,240,0.04))",
        border: `1px solid rgba(115,102,240,0.2)`,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ fontSize: 28, flexShrink: 0, color: DS.accent }}>♕</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 14, color: DS.text }}>Global Leaderboard</div>
            <div style={{ fontSize: 12, color: DS.textMuted, marginTop: 3, lineHeight: 1.5 }}>
              Live rankings are coming soon — your stats are already being tracked.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function StatBox({ value, sub, color, suffix }) {
  return (
    <div style={{
      background: DS.elevated, border: `1px solid ${DS.borderFaint}`,
      borderRadius: 10, padding: "14px 12px", textAlign: "center",
    }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: color || DS.text, lineHeight: 1 }}>{value}{suffix && <span style={{ fontSize: 16, color: DS.gold }}>{suffix}</span>}</div>
      <div style={{ fontSize: 10, color: DS.textFaint, marginTop: 5, textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600 }}>{sub}</div>
    </div>
  );
}

const card = {
  background: DS.surface, border: `1px solid ${DS.borderFaint}`,
  borderRadius: DS.radius, padding: "18px 20px", marginBottom: 16,
};

const label = {
  fontFamily: "'Cinzel', Georgia, serif",
  fontSize: 10, fontWeight: 700, color: DS.textFaint,
  textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 14,
};
